import { Popover } from 'primeng/popover'

import { checkIsElementAttached } from '../../layout/utils'

export function patchPopover() {
  /**
   * Patch the Popover hide method to fix stale overlays due to custom route reuse
   *
   * PrimeNG overlays attach their content to a separate part of the DOM (outside the Angular component tree)
   * When using a custom route reuse strategy, the normal component destruction does not occur,
   * so the overlay may remain visible in the DOM even though its component is detached
   */
  const orig__Popover_hide = Popover.prototype.hide
  Popover.prototype.hide = function (...args) {
    orig__Popover_hide.call(this, ...args)

    setTimeout(() => {
      if (!checkIsElementAttached(this.el.nativeElement)) {
        this.cd.detectChanges()

        // Detach popover from the body if the component is disconnected from DOM
        if (this.container?.parentElement === document.body) {
          document.body.removeChild(this.container as HTMLElement)
        }
      }
    }, 32)
  }
}
